import { Component, Inject, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';


@Component({
    selector: 'lib-date-time-native-html5-picker',
    templateUrl: './date-time-native-html5-picker.component.html',
    styleUrls: ['./date-time-native-html5-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateTimeNativeHtml5PickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DateTimeNativeHtml5PickerComponent implements ControlValueAccessor {

  constructor(){

  }

  private onTouched!: Function;
  private onChanged!: Function;

  private _date: string;
  private _time: string;

  get date(): string {
    return this._date;
  }

  set date(date: string) {
    this._date = date;
    this.emitUpdate();
  }

  get time(): string {
    return this._time;
  }

  set time(time: string) {
    if (time ===""){
      this._time = null;
    }else{
      this._time = time;
    }
    this.emitUpdate();
  }

  emitUpdate(): void {
    if (this.date && this.time){
      this.onChanged(moment(`${this.date} ${this.time}`, 'YYYY-MM-DD HH:mm').toDate());
    }else if (this.date && this.time == null){
      this.onChanged(moment(`${this.date}`, 'YYYY-MM-DD').toDate());
    }else{
       this.onChanged(null);
    }
  }

  writeValue(obj: any): void {
    if (obj == null){
      this._date = null;
      this._time = null;
    }else if (obj instanceof Date){
      this._date = moment(obj).format('YYYY-MM-DD');
      this._time = moment(obj).format('HH:mm');
    }
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {

  }

}
